import { styled } from "styled-components";
import ProfileHeader from "../components/ProfileHeader";
import ProfileSubscription from "../components/ProfileSubscription";
import { withAuth } from "../../auth/helpers/hoc";
import { useAuth } from "../../auth/contexts/auth.provider";

import {
  Loading,
  scrollBarStyles,
  useDocumentTitle,
  Authority,
  useMountedEffect,
} from "@dataone/lib";
import GuestView from "../components/GuestView";
import ProfileInformation from "../components/ProfileInformation";
import { Outlet, useRoutes } from "react-router-dom";
import { ProfileRoutes } from "../routes/profile.routes";

const ProfilePage = () => {
  const { user, getCurrentUser } = useAuth();

  useDocumentTitle("OneGate | Profile");

  useMountedEffect(() => {
    getCurrentUser();
  }, []);
  const element = useRoutes(ProfileRoutes);

  return (
    <StyledProfilePageContainer>
      <StyledProfilePage>
        {!user ? (
          <Loading />
        ) : (
          <>
            <ProfileHeader user={user} />
            {
              // user?.subscription &&
              // <ProfileSubscription user={user} />
              // <ProfileInformation />
              element
            }
            {/* {user?.groups["0"] === Authority.OG_GUEST && <GuestView />} */}
          </>
        )}
      </StyledProfilePage>
    </StyledProfilePageContainer>
  );
};

export default withAuth(ProfilePage);
const StyledProfilePageContainer = styled.div`
  ${scrollBarStyles}
  overflow: auto;
`;
const StyledProfilePage = styled.div`
  padding: 30px 30px 50px 30px;
  display: flex;
  height: calc(100vh - 80px);

  // @media only screen and (max-width: 1118px) {
  //   display: block;
  //   justify-content: center;
  //   width: 100%;
  //   padding: 30px 0 50px 0;
  // }
`;
